export default function ArrowRightInBox() {
  return (
    <svg width="40" height="32" viewBox="0 0 48 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.75"
        y="0.75"
        width="46.5"
        height="36.5"
        rx="7.25"
        stroke="#4F55FD"
        strokeOpacity="0.5"
        strokeWidth="1.5"
      />
      <path
        d="M24.8333 14.625L29 19M29 19L24.8333 23.375M29 19L19 19"
        stroke="#4F55FD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
